import { HTTP } from './index'

/**
 * Get the Airlines data by query based on airline name
 * @param airlineQuery
 */
function getAirlinesByQuery (airlineQuery: string, language: string = 'de'): Promise<any> {
	return HTTP.get(`/airlines?query=${airlineQuery}`, 	{
		headers: {
			'X-Language': language
		}
	})
		.then(response => {
			return response.data
		})
		.catch(e => {
			// error handling
		})
}

export default {
	getAirlinesByQuery
}
